<template>
  <div v-if="dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_VIEW')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách đề nghị thanh toán</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button @click="exportExcel" class="font-medium f12 btn btn-outline-secondary">
          <i class="bx bx-download"></i> Xuất excel
        </button>
      </div>
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit="submitForm">
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <input v-model.trim="search.code" placeholder="Mã đề nghị thanh toán" />
          </div>
          <div class="form-group">
            <input v-model.trim="search.receiptCode" placeholder="Mã phiếu thu" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.reason" :options="optionReason" placeholder="Lý do hoàn tiền">
            </Select2>
          </div>
          <div class="form-group">
            <Select2
              v-model="search.kpiStatus"
              :options="Config.getSearch(Config.kpiStatus)"
              placeholder="Tình trạng KPI"
            >
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.creatorId" :options="optionCreator" placeholder="Người tạo">
            </Select2>
          </div>
          <div class="form-group">
            <Select2 v-model="search.status" :options="optionStatus" placeholder="Trạng thái">
            </Select2>
          </div>
          <div class="form-group">
            <input v-model.trim="search.refundCode" placeholder="Mã BBTH" />
          </div>
          <div class="form-group">
            <DateRangePicker
              class="w-100"
              :ranges="false"
              @update="transfromDatePayment()"
              v-model="dateRangePayment"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian chi tiền
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group form-group-action">
            <button
              @click="submitForm"
              class="pt-2 mr-2 btn btn-primary hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Lọc
            </button>
            <button
              @click="removeForm"
              class="pt-2 mr-2 btn btn-outline-light hc-37"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              title="Bỏ lọc"
            >
              <i class="bx bx-filter-alt"></i>
              <span class="ml-1"></span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <span><b>Tổng nhóm công việc</b>: {{ pagination.total }}</span>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              hover
              responsive
              :items="dataOrder"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(createdTime)="data">
                {{ data.item.createdTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(creator)="data">
                {{ data.item.creator.name }} <br />
                <span class="text-primary">{{ data.item.creator.email }}</span>
              </template>
              <template #cell(reason)="data">
                {{ data.item.reason | mapTextStatus(optionReason) }}
              </template>
              <template #cell(receipt)="data">
                <a href="javascript:;" @click="openReiceipt(data.item)">{{
                  data.item.receiptCode
                }}</a
                ><br />
                Ngày thu: {{ data.item.receiptTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(contract)="data">
                <a href="javascript:;" @click="openContract(data.item)">{{
                  data.item.contractCode
                }}</a
                ><br />
                Ngày ký: {{ data.item.signTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(kpiStatus)="data">
                {{ data.item.kpiStatus | transformData(Config.kpiStatus) }}
              </template>
              <template #cell(refundAmount)="data">
                {{ data.item.refundAmount | transformMoney }}
              </template>
              <template #cell(paymentTime)="data">
                {{ data.item.paymentTime | formatDate('HH:mm, DD/MM/YYYY') }}
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="[data.item.status ? data.item.status : '']">
                  {{ data.item.status | mapTextStatus(optionStatus) }}
                </span>
              </template>
              <template #cell(action)="data">
                <b-dropdown id="dropdown-1" class="m-md-2" variant="outline-light">
                  <b-dropdown-item @click="detailOrder(data.item.id)">Chi tiết</b-dropdown-item>
                  <b-dropdown-item
                    @click="downloadPaymentVoucher(data.item)"
                    v-if="['APPROVED', 'SUCCESS'].includes(data.item.status)"
                    >Tải chứng từ chi</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_PAY') &&
                      data.item.status === 'WAIT_APPROVE'
                    "
                    @click="openChangeKpiStatus(data.item)"
                    >Đổi tình trạng KPI</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_PAY') &&
                      data.item.status === 'APPROVED'
                    "
                    @click="createOrder(data.item)"
                    >Hoàn tiền</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_APPROVE') &&
                      data.item.status === 'WAIT_APPROVE'
                    "
                    @click="approve(data.item.id)"
                    >Duyệt</b-dropdown-item
                  >
                  <b-dropdown-item
                    v-if="
                      dataPermission.includes('CNPS_SCON_ORDER_PAYMENT_APPROVE') &&
                      data.item.status === 'WAIT_APPROVE'
                    "
                    @click="reject(data.item.id)"
                    >Từ chối</b-dropdown-item
                  >
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <div class="pagination-bottom">
        <b-pagination
          class="mr-2 fl-right"
          v-model="search.page"
          :total-rows="pagination.total"
          :per-page="search.limit"
        ></b-pagination>
      </div>
    </div>

    <b-modal v-model="payModal" centered size="lg">
      <template #modal-header="{ close }">
        <h5>Thông tin chi tiền hoàn</h5>
        <b-button
          size="sm"
          variant="light"
          @click="
            close(), (reqPay = { imagePayments: [] }), (paymentTime = null), (payModal = false)
          "
        >
          x
        </b-button>
      </template>
      <ValidationObserver class="w-100" ref="formPay">
        <form @submit.prevent="checkValidate">
          <div class="row">
            <div class="col-md-6">
              <ValidationProvider
                rules="required|minMaxName_7"
                vid="voucherCode"
                name="Mã chứng từ chi"
              >
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Mã chứng từ chi<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <input v-model.trim="reqPay.voucherCode" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="bankPayment" name="Tên ngân hàng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Ngân hàng chi<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <Select2 :options="listBank" v-model="reqPay.bankPayment"></Select2>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required" vid="paymentTime" name="Thời gian chi">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label"
                    >Thời gian chi<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-8">
                    <v-date-picker
                      v-model="paymentTime"
                      mode="dateTime"
                      locale="vi-VN"
                      is24hr
                      :attributes="[{ dot: true, dates: new Date() }]"
                    >
                      <template v-slot="{ inputValue, inputEvents }">
                        <input readonly :value="inputValue || '---'" v-on="inputEvents" />
                      </template>
                    </v-date-picker>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_1" vid="note" name="Ghi chú">
                <div class="form-group row" slot-scope="{ errors }">
                  <label for="" class="col-sm-4 col-form-label">Ghi chú</label>
                  <div class="col-sm-8">
                    <input v-model="reqPay.note" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
            <div class="col-md-6">
              <h6>Upload ảnh</h6>
              <div class="form-group img-list">
                <ul class="m-0">
                  <li v-for="(item, index) in reqPay.imagePayments" :key="index">
                    <a href="#popup-slider" data-toggle="modal">
                      <img :src="item" />
                      <span @click="removeImg(index)">
                        <i class="bx bx-trash bx-sm"></i>
                      </span>
                    </a>
                  </li>
                  <li>
                    <div
                      v-if="loadingImage"
                      class="add-img d-flex align-content-center justify-content-center"
                    >
                      <div class="text-center">
                        <i class="bx bx-loader-circle bx-spin bx-rotate-90 h1"></i>
                      </div>
                    </div>
                    <div
                      v-else-if="reqPay.imagePayments && reqPay.imagePayments.length < 10"
                      class="add-img"
                    >
                      <span class="text-center bx bx-plus"></span>
                      <input
                        type="file"
                        ref="fileImgPay"
                        accept="image/jpeg, image/png"
                        @input="onSelectFile"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="checkValidate"> Đồng ý </b-button>
      </template>
    </b-modal>

    <b-modal v-model="kpiStatusModal" ignore-enforce-focus-selector="input" centered size="md">
      <template #modal-header="{ close }">
        <h5>Đổi tình trạng KPI</h5>
        <b-button size="sm" variant="light" @click="close()">x</b-button>
      </template>
      <form @submit.prevent="changeKpiStatus">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Tình trạng KPI</label>
          <div class="col-sm-8">
            <Select2 :options="Config.kpiStatus" v-model="kpiStatusValue"></Select2>
          </div>
        </div>
      </form>
      <template #modal-footer="{}">
        <b-button variant="primary" @click="changeKpiStatus"> Đồng ý </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ReceiptService } from '@/services/receipts.service'
  import { StaffService } from '@/services/staff.service'
  import { BankService } from '@/services/bank.service'
  import { CommonService } from '@/services/common.service'
  import Config from '@/thirdParty/config'
  import moment from 'moment'
  import DateRangePicker from 'vue2-daterange-picker'
  import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
  import prepareQueryParamsMixin from '@/mixins/prepareQueryParamsMixin'
  import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css'
  import cloneDeep from 'lodash/cloneDeep'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'createdTime', label: 'Thời gian tạo' },
    { key: 'code', label: 'Mã ĐNTT' },
    { key: 'reason', label: 'Lý do hoàn tiền' },
    { key: 'receipt', label: 'Phiếu thu' },
    { key: 'contract', label: 'Hợp đồng' },
    { key: 'kpiStatus', label: 'Tình trạng KPI' },
    { key: 'refundCode', label: 'Mã BBHT' },
    { key: 'refundAmount', label: 'Số tiền hoàn' },
    { key: 'paymentTime', label: 'Thời gian chi' },
    { key: 'reasonReject', label: 'Lý do từ chối' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'creator', label: 'Người tạo' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    components: {
      DateRangePicker,
    },
    data() {
      return {
        Config,
        tbLoading: false,
        showLoading: false,
        fieldsTable,
        filterTable: fieldsTable,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataOrder: [],
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRangePayment: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
        optionStatus: [{ id: '0', text: 'Tất cả' }, ...Config.paymentOrderStatus],
        optionCreator: [],
        optionReason: [
          { id: '0', text: 'Tất cả' },
          { id: 'SOFTWARE_DEVICE', text: 'Hoàn tiền thiết bị/phần mềm' },
          { id: 'RENT_LEND', text: 'Hoàn tiền cọc cho thuê/cho mượn' },
          { id: 'CONTRACT_COINCIDENCE', text: 'Hoàn tiền do thanh toán trùng hợp đồng' },
        ],
        listBank: [],
        reqPay: {
          imagePayments: [],
        },
        kpiStatusModal: false,
        kpiStatusValue: null,
        kpiStatusId: null,
        loadingImage: false,
        payModal: false,
        paymentTime: null,
        configPicker: {
          format: 'HH:mm DD/MM/YYYY',
          useCurrent: true,
        },
      }
    },
    created() {
      this.fetchData()
      this.listCreator()
      this.getListBank()
    },
    mixins: [prepareQueryParamsMixin],
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
      useInUrlQueryPropList() {
        return this.prepareQueryParamsMixin({
          limit: this.search.limit,
          page: this.search.page,
        })
      },
    },
    watch: {
      'search.page': function () {
        this.$router.replace({
          query: this.useInUrlQueryPropList,
        })
        this.fetchData()
      },
    },
    methods: {
      openChangeKpiStatus(data) {
        this.kpiStatusValue = data.kpiStatus ?? Config.kpiStatus[0].id
        this.kpiStatusId = data.id
        this.kpiStatusModal = true
      },
      async changeKpiStatus() {
        try {
          this.showLoading = true
          const res = await ReceiptService.changeKpiStatus({
            id: this.kpiStatusId,
            kpiStatus: this.kpiStatusValue,
          })
          if (res.success) {
            this.fetchData()
            this.showSuccessMx('Đổi tình trạng KPI thành công')
          } else this.showFailMx(res.message)
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
          this.kpiStatusModal = false
        }
      },
      detailOrder(id) {
        window.open(`/list-order/${id}`, '_blank')
      },
      transfromDate() {
        this.search.dateFrom = moment(this.dateRange.startDate).startOf('day').valueOf()
        this.search.dateTo = moment(this.dateRange.endDate).endOf('day').valueOf()
      },
      transfromDatePayment() {
        this.search.paymentFrom = moment(this.dateRangePayment.startDate).startOf('day').valueOf()
        this.search.paymentTo = moment(this.dateRangePayment.endDate).endOf('day').valueOf()
      },
      async submitForm(event) {
        event.preventDefault()
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangePayment = {
          startDate: null,
          endDate: null,
        }
        await this.fetchData()
      },
      async listCreator() {
        try {
          const data = await StaffService.getStaffByIdSuperior({
            userId: JSON.parse(localStorage.getItem('userData')).userId,
          })
          if (data.success) {
            this.optionCreator = data.data.map(e => {
              return {
                id: e.userId,
                text: e.name,
              }
            })
            this.optionCreator.unshift({ id: '0', text: 'Tất cả' })
          }
        } catch (e) {
          console.log(e)
        }
      },
      async reject(id) {
        const { value: flag, note } = await this.rejectMx()
        if (flag === true) {
          try {
            this.showLoading = true
            const res = await ReceiptService.rejectOrder({ id: id, reason: note })
            if (res.success) {
              await this.fetchData()
              this.showSuccessMx('Từ chối thành công')
            } else this.showFailMx(res.message)
          } catch (e) {
            console.log(e)
          } finally {
            this.showLoading = false
          }
        }
      },
      async approve(id) {
        try {
          this.showLoading = true
          const res = await ReceiptService.approveOrder({
            id: id,
          })
          if (res.success) {
            await this.fetchData()
            this.showSuccessMx('Duyệt thành công')
          } else this.showFailMx(res.message)
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = cloneDeep(this.search)
          for (const key in params) {
            if (params[key] === '0') delete params[key]
          }
          const data = await ReceiptService.listOrder(params)
          if (data.success) {
            this.dataOrder = data.data.orderPaymentRes
            this.pagination.total = data.data.count
          }
        } catch (e) {
          console.log(e)
        } finally {
          this.tbLoading = false
        }
      },
      async exportExcel() {
        try {
          this.showLoading = true
          delete this.search.limit
          delete this.search.page
          await ReceiptService.exportOrder(this.search)
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
      async downloadPaymentVoucher(item) {
        try {
          this.showLoading = true
          const data = await ReceiptService.getPaymentVoucher(item.id)
          await ReceiptService.genPaymentVoucher(data.data)
        } catch (e) {
          console.log(e)
        } finally {
          this.showLoading = false
        }
      },
      createOrder(item) {
        this.reqPay.orderPaymentId = item.id
        this.payModal = true
      },
      async getListBank() {
        try {
          const data = await BankService.listBank()
          if (data.success) {
            this.listBank = data.data.map(e => {
              return {
                id: e.id,
                text: e.bankName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
      async onSelectFile() {
        const input = this.$refs.fileImgPay
        const files = input.files
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {}
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
        await this.uploadS3(files[0])
      },
      removeImg(index) {
        this.reqPay.imagePayments.splice(index, 1)
        // this.reqPay.imagePayments.forEach((item, i) => {
        //   if (index === i) {
        //     this.reqPay.imagePayments.splice(i, item)
        //   }
        // })
      },
      async uploadS3(file) {
        try {
          if (file) {
            this.loadingImage = true
            const formData = new FormData()
            formData.append('files', file)
            formData.append('folderName', 'NextCrm')
            const res = await CommonService.uploadImg(formData)
            if (res.code === 1000) {
              this.reqPay.imagePayments.push(res.data[0])
            }
          }
        } catch (error) {
        } finally {
          this.loadingImage = false
        }
      },
      async checkValidate() {
        const isSuccess = await this.$refs.formPay.validate()
        if (!isSuccess) {
          return
        }
        this.reqPay.paymentTime = moment(this.paymentTime, this.configPicker.format).valueOf()
        this.payOrder()
      },
      openReiceipt(data) {
        window.open(`/detail-receipts/${data.receiptId}`)
      },
      openContract(data) {
        if (data.groupService === 'SELL') {
          if (data.formContract === 'E_CONTRACT') {
            window.open(`/sales-manager/detail/${encodeURIComponent(data.contractId)}`, '_blank')
          } else {
            window.open(
              `/sales-manager/detail-paper/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          }
        } else {
          if (data.formContract === 'E_CONTRACT') {
            window.open(
              `/contract-detail-ecommerce/${encodeURIComponent(data.contractId)}`,
              '_blank'
            )
          } else {
            window.open(`/contract-detail-paper/${encodeURIComponent(data.contractId)}`, '_blank')
          }
        }
      },
      async payOrder() {
        try {
          this.showLoading = true
          const data = await ReceiptService.payOrder(this.reqPay)
          if (data.success) {
            this.payModal = false
            this.$nextTick(() => {
              this.showSuccessMx('Hoàn tiền thành công')
            })
            this.reqPay = {
              imagePayments: [],
            }
            this.paymentTime = null
            await this.fetchData()
          } else {
            this.showFailMx(data.message)
          }
        } catch (e) {
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>

<style></style>
